import { render } from "./ExamFilesModal.vue?vue&type=template&id=3389fcb3&scoped=true"
import script from "./ExamFilesModal.vue?vue&type=script&lang=js"
export * from "./ExamFilesModal.vue?vue&type=script&lang=js"

import "./ExamFilesModal.vue?vue&type=style&index=0&id=3389fcb3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3389fcb3"]])

export default __exports__